/* WeltPartner — Handelspartner Detailseite (composable page sections,
 * sections/wp-hp-*.liquid; loaded by sections/wp-hp-inhalt.liquid)
 *
 * initToc — builds the "Inhalt" table of contents from the article's rendered
 * h2/h3 headings (the article body is metaobject rich text, so headings carry
 * no ids in the markup) and drives the scrollspy active state. Without JS the
 * aside keeps its [hidden] attribute.
 *
 * The page's two sliders live in assets/wp-slider.js: the looping gallery is
 * <wp-image-slider>, the "Produkte in diesem Artikel" rail is <wp-scroll-rail>.
 */
(function () {
  'use strict';

  /* ── 1. Table of contents + scrollspy ─────────────────────────────────── */
  function initToc(root) {
    const aside = root.querySelector('[data-wp-toc]');
    const list = root.querySelector('[data-wp-toc-list]');
    if (!aside || !list) return;
    const headings = [...root.querySelectorAll('.wp-hp__rte h2, .wp-hp__rte h3')];
    if (!headings.length) return;

    const links = headings.map((h) => {
      if (!h.id) {
        const slug = h.textContent.trim().toLowerCase()
          .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
          .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
          .slice(0, 60) || 'abschnitt';
        let id = slug;
        let n = 2;
        while (document.getElementById(id)) id = slug + '-' + n++;
        h.id = id;
      }
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.className = 'wp-hp__toc-link';
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });
    aside.hidden = false;

    // Desktop sticky span: the aside is absolute inside a zero-height section,
    // so give it the height down to the last article section (see
    // .wp-hp__layout--inhalt in src/app.css); the card sticks within it.
    // Walk the contiguous run of article sections after the ToC: a product
    // slider / hero (Abschluss) ends it, even if another text block follows.
    let last = aside.closest('.shopify-section') || aside;
    for (let n = last.nextElementSibling; n && n.querySelector('.wp-hp__layout--sec'); n = n.nextElementSibling) last = n;
    const span = () => aside.style.setProperty('--wp-toc-span',
      (last.getBoundingClientRect().bottom - aside.getBoundingClientRect().top) + 'px');
    new ResizeObserver(span).observe(document.body);

    // Sticky card vs. breite Medienblöcke (Slider/Vollbild/Video) in derselben Spalte:
    // überlappt die Karte einen davon, ausblenden statt verdecken (Kundenfeedback 09.09.).
    const card = aside.querySelector('.wp-hp__toc-card');
    const wide = [...root.querySelectorAll('.wp-hp__wide, .wp-hp__bleed')];
    let ticking = false;
    const obscure = () => {
      ticking = false;
      if (!card || getComputedStyle(card).position !== 'sticky') return;
      const c = card.getBoundingClientRect();
      const hit = wide.some((w) => { const r = w.getBoundingClientRect(); return r.bottom > c.top && r.top < c.bottom && r.left < c.right; });
      card.classList.toggle('is-obscured', hit);
    };
    const onObscure = () => { if (!ticking) { ticking = true; requestAnimationFrame(obscure); } };
    addEventListener('scroll', onObscure, { passive: true }); addEventListener('resize', onObscure); obscure();

    // Scrollspy: active = last heading whose top has passed the 160px line
    // (mirrors the headings' scroll-margin-top so click + scroll agree).
    const setActive = (id) => links.forEach((a) => {
      a.classList.toggle('is-active', a.getAttribute('href') === '#' + id);
    });
    const spy = () => {
      let current = headings[0].id;
      for (const h of headings) {
        if (h.getBoundingClientRect().top <= 160) current = h.id;
        else break;
      }
      setActive(current);
    };
    let raf = 0;
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(() => { raf = 0; spy(); });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    spy();
  }

  // Composable pages have no .wp-hp wrapper — scan the document. On the legacy
  // metaobject template this is equivalent (one article per page either way).
  initToc(document);
})();
